export const SETPASSWORDREQUEST = "SETPASSWORDREQUEST"
export const SETPASSWORDFAILURE = "SETPASSWORDFAILURE"
export const SETPASSWORDSUCCESS = "SETPASSWORDSUCCESS"
export const SETPASSWORDSCORRECTRESPONSETOMOVEFORWARD = "Password updated successfully!"